'use strict';

module.exports = function (data) {
  this.data = this.applyFilters(data.data);
  this.count = parseInt(data.count);

  setTimeout(function () {
    this.dispatch('loaded', data);
  }.bind(this), 0);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/set-data.js
// module id = 265
// module chunks = 0